<template>
<div class="chapter">
<div class="inner_page">
<div><a id="ack"></a></div>
<div class="top15">
<p class="textbreak"><strong>Acknowledgements</strong></p>
</div>
<p>Of course I’d like to give thanks to the creator, as well as my parents Patricia and Kenny for giving me life, and the talent that I possess.</p>
<p>They, along with my grandmother Ms. Julia Anne; my brother Tiffon; my daughter Daisha; my step-mother Margo; my cousins Paul, Pierre, DeShaun, Chris and Sheniqua; my aunts Darsal and Cecelia; my
  nieces Tatiana and Alexis; my uncle Mike, my good friends Joel Payne, Khiry, Chianne, Big Lamont, Jacqie, Shawna, Aja, Charmaine, Makeda, and Sandy, have been there for me during this tumultuous
  time in my life, and for that I’m truly grateful.</p>
<p>Also I’d like to give a shout out to a few good people behind the wall like Emmitt Wesson, Timothy Bluitt, Criccet, Ron Ricco, GB, Third, Tee, Slim, Rommell, Wise, D. Comer, Kahlil,
  Kalief, Ms. Jackie Brown and Mr. Kent McKinney. And I’d like to thank Rally, Steady, Alphonzo Strong, and Abdul for all the feedback and constructive criticism.</p>
<p>A special thanks goes to my man Joel Randell for his friendship and inspiration, which played a major role in me writing this book; and John “JF” Ferguson, for seeing my vision,
  believing in me, and pushing the buttons necessary to get this book out. I would also like to thank Lewis LaMonica for helping me with the edits, and Jada Black for laying out the design.</p>
<p>Finally, to my sister Michelle: We’ve had our ups and downs, but know that I love you dearly and want nothing but the best for you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_ack.vue?973286e2